/*
 * STORMWARD · Verkaufselemente (Muster: Men Go To Mars, Analyse 08.10.2026)
 * ---------------------------------------------------------------------------
 * Global geladen (layout/theme.liquid, defer). Jeder Baustein ist ein
 * eigenes Custom Element oder ein delegierter Klick, damit Dawns
 * Section-Rendering (Warenkorb, Varianten) nichts kaputt macht.
 *
 *   <sw-countdown>   Angebotsleiste: zaehlt auf ein ECHTES Enddatum, nie zurueck.
 *   <sw-sticky-atc>  Kaufleiste unten, sobald der Kaufknopf aus dem Bild ist.
 *   <sw-popup>       Angebots-Popup, drei Schritte, einmal je N Tage.
 *   [data-sw-cart-add]  Warenkorb: Menge auf die naechste Stufe setzen.
 *   [data-sw-scroll]    Links zur Kaufbox scrollen auf der Produktseite,
 *                       statt die Seite neu zu laden.
 *
 * Kein eigener Kaufweg: Kaufen laeuft immer ueber Dawns <product-form>.
 */
(function () {
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
  };

  /* ---------- Countdown ---------------------------------------------------- */
  class SWCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end || '');
      if (Number.isNaN(this.end)) return;
      this.units = {};
      this.querySelectorAll('[data-unit]').forEach((el) => { this.units[el.dataset.unit] = el; });
      this.hidden = false;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const left = Math.max(0, this.end - Date.now());
      if (left === 0) {
        clearInterval(this.timer);
        this.textContent = this.dataset.done || '';
        return;
      }
      const s = Math.floor(left / 1000);
      const v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      Object.keys(v).forEach((k) => { if (this.units[k]) this.units[k].textContent = String(v[k]).padStart(2, '0'); });
      this.classList.toggle('sw-countdown--nodays', v.d === 0);
    }
  }
  if (!customElements.get('sw-countdown')) customElements.define('sw-countdown', SWCountdown);

  /* ---------- 6-Stunden-Countdown in der Angebotsbox ---------------------- */
  // Ansage Moritz 08.10.2026: zaehlt je Besucher immer von 6 Stunden herunter und
  // beginnt danach von vorn. Startzeit liegt im localStorage, sonst ab Seitenaufruf.
  class SWEvergreen extends HTMLElement {
    connectedCallback() {
      this.clock = this.querySelector('[data-sw-clock]');
      if (!this.clock) return;
      const span = Math.max(1, Number(this.dataset.hours || 6)) * 3600000;
      const key = this.dataset.key || 'sw-evergreen';
      let start = Number(store.get(key) || 0);
      if (!start || start > Date.now()) { start = Date.now(); store.set(key, String(start)); }
      this.span = span; this.start = start;
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const left = this.span - ((Date.now() - this.start) % this.span);
      const s = Math.floor(left / 1000);
      const p = (n) => String(n).padStart(2, '0');
      this.clock.textContent = `${p(Math.floor(s / 3600))}:${p(Math.floor((s % 3600) / 60))}:${p(s % 60)}`;
    }
  }
  if (!customElements.get('sw-evergreen')) customElements.define('sw-evergreen', SWEvergreen);

  /* ---------- Sticky-Kaufleiste ------------------------------------------- */
  class SWStickyATC extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      this.tierEl = this.querySelector('[data-sw-sticky-tier]');
      this.priceEl = this.querySelector('[data-sw-sticky-price]');
      this.onTier = (e) => this.setTier(e.detail);
      document.addEventListener('sw:tier', this.onTier);
      this.readInitial();

      this.anchor = this.form && (this.form.querySelector('.product-form__submit') || this.form);
      if (!this.anchor) return;
      // Scroll statt IntersectionObserver: Der Observer meldet keinen Wechsel
      // zwischen "unter dem Sichtfeld" und "ueber dem Sichtfeld" (Sprunglinks),
      // dann bliebe die Leiste oben stehen.
      this.footer = document.querySelector('.footer, footer');
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          const passed = this.anchor.getBoundingClientRect().bottom < 0;
          const footerIn = this.footer ? this.footer.getBoundingClientRect().top < window.innerHeight : false;
          this.toggle(passed);
          this.classList.toggle('is-footer', footerIn);
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      document.removeEventListener('sw:tier', this.onTier);
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    }
    readInitial() {
      const checked = document.querySelector('.sw-tiers__input:checked');
      if (checked) this.setTier({ name: checked.dataset.name, price: checked.dataset.price });
    }
    setTier(d) {
      if (!d) return;
      if (this.tierEl) this.tierEl.textContent = d.name || '';
      if (this.priceEl) this.priceEl.textContent = d.price ? `· ${d.price}` : '';
    }
    toggle(show) {
      if (show === this.shown) return;
      this.shown = show;
      if (show) this.hidden = false;
      requestAnimationFrame(() => this.classList.toggle('is-visible', show));
      document.documentElement.classList.toggle('sw-sticky-on', show);
    }
  }
  if (!customElements.get('sw-sticky-atc')) customElements.define('sw-sticky-atc', SWStickyATC);

  /* ---------- Popup --------------------------------------------------------- */
  class SWPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = 'sw-popup-seen';
      this.days = Number(this.dataset.days || 7);

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-sw-popup-close]')) return this.close();
        if (e.target.closest('[data-sw-popup-next]')) return this.step(2);
        if (e.target === this.dialog) return this.close();
      });
      this.dialog.addEventListener('cancel', (e) => { e.preventDefault(); this.close(); });

      // Nach dem Absenden laedt Shopify die Seite neu: Schritt 3 sofort zeigen.
      if (this.querySelector('[data-step="3"][data-posted]') || /[?&]customer_posted=true/.test(location.search)) {
        this.open(3);
        return;
      }
      // Fehler im Formular (z. B. ungueltige Adresse): Schritt 2 wieder oeffnen.
      if (this.querySelector('.sw-popup__error')) {
        this.open(2);
        return;
      }
      if (this.hasAttribute('data-editor')) {
        this.open(1);
        return;
      }
      const seen = Number(store.get(this.key) || 0);
      if (seen && Date.now() - seen < this.days * 86400000) return;

      const delay = Math.max(2, Number(this.dataset.delay || 6)) * 1000;
      this.timer = setTimeout(() => this.open(1), delay);
      this.onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) this.open(1); };
      document.addEventListener('mouseout', this.onLeave);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
    }
    open(n) {
      clearTimeout(this.timer);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
      if (this.dialog.open) return;
      // Kein Popup ueber offenem Warenkorb oder Upgrade-Fenster.
      if (document.querySelector('cart-drawer.active, dialog.sw-upgrade[open]')) return;
      store.set(this.key, String(Date.now()));
      this.step(n);
      this.dialog.showModal();
      document.documentElement.classList.add('sw-popup-open');
    }
    step(n) {
      this.querySelectorAll('[data-step]').forEach((el) => { el.hidden = el.dataset.step !== String(n); });
      const focus = this.querySelector(`[data-step="${n}"] input[type="email"], [data-step="${n}"] .sw-popup__btn`);
      if (focus) setTimeout(() => focus.focus(), 30);
    }
    close() {
      if (this.dialog.open) this.dialog.close();
      document.documentElement.classList.remove('sw-popup-open');
    }
  }
  if (!customElements.get('sw-popup')) customElements.define('sw-popup', SWPopup);

  /* ---------- Bausteine unter die Galerie setzen ------------------------- */
  // Dawns main-product hat keine Bloecke in der Bildspalte. Bausteine mit
  // data-sw-move="media" werden in der Kaufspalte gerendert und hier unter die
  // Galerie gehaengt; bis dahin blendet sw-sections.css sie aus.
  const moveToMedia = () => {
    document.querySelectorAll('[data-sw-move="media"]:not(.is-moved)').forEach((el) => {
      const scope = el.closest('.product, .shopify-section') || document;
      const media = scope.querySelector('.product__media-wrapper');
      if (!media) return;
      media.appendChild(el);
      el.classList.add('is-moved');
    });
  };
  moveToMedia();
  document.addEventListener('shopify:section:load', moveToMedia);

  /* ---------- Delegierte Klicks ------------------------------------------- */
  // Warenkorb: der Schalter zaehlt BEZAHLTE Filter. Die Gesamtmenge ist die groesste
  // Menge mit genau so vielen bezahlten Filtern, damit jeder Gratis-Filter mitkommt.
  // Regeln wie die automatischen Rabatte: 2 kaufen 1 gratis, 3 kaufen 2, 4 kaufen 4.
  const SW_RULES = [[2, 1], [3, 2], [4, 4]];
  const SW_FILTER = 'grid-down-filter';
  const swFree = (n) => SW_RULES.reduce((m, [b, g]) => Math.max(m, Math.min(g, n - b)), 0);
  const swTotalFor = (paid) => {
    if (paid <= 0) return 0;
    let best = paid;
    for (let n = paid; n <= paid + 8; n += 1) if (n - swFree(n) === paid) best = n;
    return best;
  };

  // Shopify teilt den Filter bei Gratis-Stufen in zwei Zeilen (bezahlt und 0 $). Darum
  // setzen wir die GESAMTmenge ueber alle Filterzeilen per /cart/update.js und zeichnen
  // den Warenkorb mit Dawns eigenen Abschnitten neu (wie cart.js updateQuantity).
  let swBusy = false;
  const swSetFilterTotal = async (target) => {
    if (swBusy) return;
    swBusy = true;
    const items = document.querySelector('cart-drawer-items');
    const drawer = document.querySelector('cart-drawer');
    if (items) items.classList.add('sw-is-loading');
    try {
      const cart = await fetch(`${routes.cart_url}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const lines = cart.items.filter((i) => i.handle === SW_FILTER);
      if (!lines.length) return;
      const others = lines.slice(1).reduce((sum, l) => sum + l.quantity, 0);
      const updates = {};
      if (target >= others) {
        updates[lines[0].key] = target - others;
      } else {
        lines.forEach((l) => { updates[l.key] = 0; });
        updates[lines[0].key] = target;
      }
      const sections = items && typeof items.getSectionsToRender === 'function' ? items.getSectionsToRender() : [];
      const config = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
      const state = await fetch(`${routes.cart_update_url || '/cart/update'}`, {
        ...config,
        body: JSON.stringify({ updates, sections: sections.map((sec) => sec.section), sections_url: window.location.pathname }),
      }).then((r) => r.json());
      if (state.errors || !state.sections) { window.location.reload(); return; }
      sections.forEach((sec) => {
        const host = document.getElementById(sec.id);
        if (!host || !state.sections[sec.section]) return;
        const el = host.querySelector(sec.selector) || host;
        el.innerHTML = items.getSectionInnerHTML(state.sections[sec.section], sec.selector);
      });
      const empty = state.item_count === 0;
      if (items) items.classList.toggle('is-empty', empty);
      if (drawer) drawer.classList.toggle('is-empty', empty);
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sw-filter-total', cartData: state });
      }
    } catch (err) {
      window.location.reload();
    } finally {
      swBusy = false;
      const fresh = document.querySelector('cart-drawer-items');
      if (fresh) fresh.classList.remove('sw-is-loading');
    }
  };

  document.addEventListener('click', (e) => {
    // Warenkorb: bezahlte Filter rauf oder runter.
    const step = e.target.closest('[data-sw-paid-step]');
    if (step) {
      e.preventDefault();
      const box = step.closest('[data-sw-paid]');
      if (!box) return;
      const paid = Number(box.dataset.swPaid) + Number(step.dataset.swPaidStep);
      const total = swTotalFor(paid);
      if (total !== Number(box.dataset.swTotal)) swSetFilterTotal(total);
      return;
    }

    // Warenkorb: alle Filter entfernen (alle Teilzeilen).
    if (e.target.closest('[data-sw-filter-remove]')) {
      e.preventDefault();
      swSetFilterTotal(0);
      return;
    }

    // Warenkorb: auf naechste Stufe aufstocken (Gesamtmenge aller Filterzeilen).
    const add = e.target.closest('[data-sw-cart-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      swSetFilterTotal(Number(add.dataset.qty));
      return;
    }

    // Links zur Kaufbox: auf der Produktseite weich scrollen statt neu laden.
    const link = e.target.closest('a[data-sw-scroll]');
    if (link) {
      const target = document.getElementById(link.dataset.swScroll);
      if (!target) return;
      let qty = null;
      try { qty = new URL(link.href, location.href).searchParams.get('qty'); } catch (err) {}
      e.preventDefault();
      if (qty) {
        const hit = target.querySelector(`.sw-tiers__input[data-total="${qty}"]:not(:disabled)`);
        if (hit && !hit.checked) { hit.checked = true; hit.dispatchEvent(new Event('change', { bubbles: true })); }
      }
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    }
  });
})();
